export const BROWSER_WEB_ACCESSIBLE_RESOURCES_PROTOCOLS = /[\w]+-extension:\/\//;
export const isBrowserExtensionError = (stackFrames) => stackFrames.some(({ fileName }) => fileName && !fileName.search(BROWSER_WEB_ACCESSIBLE_RESOURCES_PROTOCOLS));
